import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  status?: "available" | "busy" | "offline" | string | null;
  size?: "small" | "medium";
};

const COLOR: Record<string, "success" | "warning" | "default"> = {
  available: "success",
  busy: "warning",
  offline: "default",
};

// Live partner availability from the dispatch system (User.availabilityStatus).
// Distinct from account `active` (a static admin flag) and from the owner
// heartbeat `isOnline`.
const AvailabilityChip = ({ status, size = "small" }: Props) => {
  const { t } = useTranslation();
  const s = status || "offline";
  const label =
    s === "available"
      ? t("status.available")
      : s === "busy"
      ? t("status.busy")
      : t("status.offline");
  return <Chip label={label} color={COLOR[s] ?? "default"} size={size} />;
};

export default AvailabilityChip;
